import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { UmsService } from '../ums.service';
import { log } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-exam-aggregate',
  templateUrl: './exam-aggregate.component.html',
  styleUrls: ['./exam-aggregate.component.scss']
})
export class ExamAggregateComponent implements OnInit, AfterViewInit {
  ExamAggForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  examaggList: any;
  list;
  ExamAFormArray;
  examagg: string;
  examaggform: any;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  ExamName: any;
  isreaddelete: boolean;
  deleteButton: boolean;
  isShowToWeight = false;
  showTable = false;
  isShowWeight = false;
  isShowPartAggr = false;
  SubTotal = false;
  isShowDesc = false;
  isShowExamCode = false;
  autoserialnumber = 0;
  x = sessionStorage.getItem('EmId');
  y = sessionStorage.getItem('EmCoCode');
  z = sessionStorage.getItem('EmDiv');
  EmId: string;
  filteredListCode: any;
  CodeList: any;
  userPermission:any;
 utp: any;
 ExAgCreate = true;
ExAgUpdate = true;
ExAgDelete = true;
  @Output() prev = new EventEmitter<void>();
  SubValue: string;
  constructor(public umsService: UmsService, private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner:NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Exam-Aggrigate' && element.PCreate == false)
      {
          this.ExAgCreate = false;  
      }
      // if(element.PageName == 'Exam-Aggrigate' && element.PUpdate == false)
      // {
      //     this.ExAgUpdate = false;  
      // }   
      if(element.PageName == 'Exam-Aggrigate' && element.PDelete == false)
      {
          this.ExAgDelete = false;  
      } 
    });
  }
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.isreaddelete = false;
    this.showTable = false;
    this.list = true;
    this.ExamAggForm = this.fb.group({
      EaEmId: new FormControl(sessionStorage.getItem('EmId')),
      EaEmName: new FormControl(sessionStorage.getItem('EmName')),
      EaAgSrNo: new FormControl(this.autoserialnumber),
      EaAgEmId: new FormControl('',Validators.required),
      // EaEmCode: new FormControl('',[Validators.required]),
      EaDesc: new FormControl('',[Validators.required]),
      EaOutOf: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      EaWeight: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      EaTotWeight: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      EaSubTot: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EaSpFlag: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')])

    });
    this.fetchCode(id);
    this.getExamAggData();
    this.fetchExam(id);
    this.select();
    this.loadsettingspage();

     
      this.SubValue = sessionStorage.getItem('EmSubTot');
      if(sessionStorage.getItem('EmSubTot') !== ''){
        this.SubTotal = true;
      }
      else{
        this.SubTotal = false;
      }
  }

  ngAfterViewInit(): void{
    
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.isreaddelete = false;
    this.showTable = false;
    this.list = true;
    this.ExamAggForm = this.fb.group({
      EaEmId: new FormControl(sessionStorage.getItem('EmId')),
      EaEmName: new FormControl(sessionStorage.getItem('EmName')),
      EaAgSrNo: new FormControl(this.autoserialnumber),
      EaAgEmId: new FormControl('',Validators.required),
      // EaEmCode: new FormControl('',[Validators.required]),
      EaDesc: new FormControl('',[Validators.required]),
      EaOutOf: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      EaWeight: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      EaTotWeight: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      EaSubTot: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EaSpFlag: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')])

    });
    this.fetchCode(id);
    this.getExamAggData();
    this.fetchExam(id);
    this.select();
    this.loadsettingspage();
  }

  download() {
    let wwe = ['EaEmId', 'EaEmName', 'EaDesc', 'EaOutOf', 'EaWeight', 'EaTotWeight', 'EaSubTot', 'EaSpFlag']
    this.umsService.downloadFile(this.examaggList, 'jsontocsv', wwe);
  }

  getExamAggData() {
    const payload = {};
    payload['EaEmId'] = sessionStorage.getItem('EmId');
    this.umsService.getExamAggr(payload).subscribe(res => {
      this.examaggList = res.data;
      this.autoserialnumber = res.data.length + 1;
      this.ExamAggForm.controls.EaAgSrNo.setValue(this.autoserialnumber);
      if(res.data.length==0){
        this.showTable = false;
      }
      else{
        this.showTable = true;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.examaggList = [];
    });
  }

  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      this.getExamAggData();
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  submit() {
    if (this.ExamAggForm.invalid) {
     
      if((this.ExamAggForm.value['EaWeight']=="") && (this.ExamAggForm.value['EaTotWeight']=="") && (this.ExamAggForm.value['EaDesc'] !="")){
        this.ExamAggForm.value['EaWeight']=0;
        this.ExamAggForm.value['EaTotWeight']=0;
        this.createExamAgg();
        this.getExamAggData();
      }
      else if((this.ExamAggForm.value['EaWeight']=="") && (this.ExamAggForm.value['EaTotWeight']=="") && (this.ExamAggForm.value['EaDesc'] =="") && (this.ExamAggForm.value['EaAgEmId'] =="")){
        this.ExamAggForm.get('EaTotWeight').markAsTouched();
        this.ExamAggForm.get('EaWeight').markAsTouched();
        this.ExamAggForm.get('EaDesc').markAsTouched();
        this.ExamAggForm.get('EaAgEmId').markAsTouched();
        this.ExamAggForm.get('EaOutOf').markAsTouched();
       
      }
      else if((this.ExamAggForm.value['EaOutOf']=="") && (this.ExamAggForm.value['EaDesc'] !="")){
        this.ExamAggForm.value['EaOutOf']=0;
        this.createExamAgg();
        this.getExamAggData();
      }
     
      else if(
        (this.ExamAggForm.value['EaDesc']=="") && 
        (this.ExamAggForm.value['EaEmName'] =="") && 
        (this.ExamAggForm.value['EaOutOf']=="") && 
        (this.ExamAggForm.value['EaSpFlag'] =="") && 
        (this.ExamAggForm.value['EaSubTot']=="") && 
        (this.ExamAggForm.value['EaTotWeight'] =="") && 
        (this.ExamAggForm.value['EaWeight']=="")){
      this.ExamAggForm.get('EaEmId').markAsTouched();
      this.ExamAggForm.get('EaEmName').markAsTouched();
      this.ExamAggForm.get('EaDesc').markAsTouched();
      this.ExamAggForm.get('EaOutOf').markAsTouched();
      this.ExamAggForm.get('EaWeight').markAsTouched();
      this.ExamAggForm.get('EaTotWeight').markAsTouched();
      this.ExamAggForm.get('EaSubTot').markAsTouched();
      this.ExamAggForm.get('EaSpFlag').markAsTouched();
      this.ExamAggForm.get('EaAgEmId').markAsTouched();
      
      return;
      }
    } else {
      this.createExamAgg();
      this.getExamAggData();
    }
  }

  createExamAgg() {
    this.spinner.show();
    this.submitpayload = this.ExamAggForm.value;
    this.umsService.addExamAggr(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.getExamAggData();
        this.ExamAggForm.controls['EaDesc'].setValue('');
        this.ExamAggForm.controls['EaAgEmId'].setValue('');
        this.ExamAggForm.controls['EaDesc'].setErrors(null);
        this.ExamAggForm.controls['EaDesc'].clearValidators();
        this.ExamAggForm.controls['EaDesc'].updateValueAndValidity();
        this.ExamAggForm.controls['EaAgEmId'].setErrors(null);
        this.ExamAggForm.controls['EaAgEmId'].clearValidators();
        this.ExamAggForm.controls['EaAgEmId'].updateValueAndValidity();
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  prepopulationForDelete(id) {
    this.prepopulatedatapage(id);
    this.editButton = false;
    this.submitButton = false;
    this.isreaddelete = true;
    this.deleteButton = true;
    this.ExamAggForm = this.fb.group({
      EaEmId: new FormControl(sessionStorage.getItem('EmId')),
      EaAgSrNo: new FormControl(id.EaAgSrNo),
      EaAgEmId: new FormControl(id.EaAgEmId,[Validators.required]),
      EaEmName: new FormControl(sessionStorage.getItem('EmName')),
      // EaEmCode: new FormControl(id.EaEmCode,[Validators.required]),
      EaDesc: new FormControl(id.EaDesc,[Validators.required]),
      EaOutOf: new FormControl(id.EaOutOf,[Validators.pattern('^[0-9]*$')]),
      EaWeight: new FormControl(id.EaWeight,[Validators.pattern('^[0-9]*$')]),
      EaTotWeight: new FormControl(id.EaTotWeight,[Validators.pattern('^[0-9]*$')]),
      EaSubTot: new FormControl(id.EaSubTot, [Validators.pattern('^[0-9]*$')]),
      EaSpFlag: new FormControl(id.EaSpFlag, [Validators.pattern('^[a-zA-Z0-9]*$')])
    });
  }

  openConformationModalBox() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.ExamAggForm.value);
      } else {
      }
    });
  }

  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EaEmId: id.EaEmId,
        EaAgSrNo: id.EaAgSrNo,
        EaAgEmId: id.EaAgEmId,
        // EaEmCode: id.EaEmCode,
        EaDesc: id.EaDesc,
        EaOutOf: id.EaOutOf,
        EaWeight: id.EaWeight,
        EaTotWeight: id.EaTotWeight,
        EaSubTot: id.EaSubTot,
        EaSpFlag: id.EaSpFlag,

      },
    };
    this.httpClient.delete(this.APIService + '/masters/exam-aggr', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngAfterViewInit();
        this.prev.emit();
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      });
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.isreaddelete = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.ExamAggForm.reset();
    } else {
      this.list = true;
    }

  }

  fetchCode(id) {
    const payload = {};
    payload['EmCoCode'] = sessionStorage.getItem('EmCoCode');;
    payload['EmId'] = '';

    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
            this.CodeList = res.data;
            this.filteredListCode = this.CodeList.slice();
          } else {
          }
        })
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  back() {
    this.prev.emit();
  }

  fetchExam(data) {
    const payload = {};
    payload['EmCoCode'] = data;
    payload['EmId'] = data;
    this.umsService.getExam(payload).subscribe(res => {
      this.ExamName = sessionStorage.getItem('EmName');
      this.x = sessionStorage.getItem('EmId');
      this.ExamAggForm.controls['EaEmName'].setValue(this.ExamName);
      if (res.status) {
      } else {
      }
    })
  }

select(){
  this.z = sessionStorage.getItem('EmDiv');
  if(this.z == 'A'){
    this.isShowExamCode = true;
    this.isShowDesc = true;
    this.isShowPartAggr = false;
    this.isShowWeight = false;
    this.isShowToWeight = false;
  }
  else if(this.z == 'P'){
    this.isShowExamCode = true;
    this.isShowDesc = true;
    this.isShowPartAggr = true;
    this.isShowWeight = false;
    this.isShowToWeight = false;
  }
  else if(this.z == 'W'){
    this.isShowExamCode = true;
    this.isShowDesc = true;
    this.isShowWeight = true;
    this.isShowToWeight = true;
    this.isShowPartAggr = false;
  }
  else{
    this.isShowExamCode = false;
    this.isShowDesc = false;
    this.isShowWeight = false;
    this.isShowToWeight = false;
    this.isShowPartAggr = false;
  }
}
prepopulatedatapage(e){
  let payload = {};
    payload['FormPage'] = 'AggregateExam';
   

  // this.ExamForm.controls['StuId'].setValue(e.data[0]['StuId']);
   this.umsService.getStdSetting(payload).subscribe((ress) => {
        ress.data.forEach((element) => {
          if (element.FormVisible) {
            if (element.FormRequired) {
              if(element.FormPattern==''){
                this.ExamAggForm.addControl(element.FormControlName,new FormControl(e.data[0][element.FormControlName], Validators.required));
         
              }
              else{
                this.ExamAggForm.addControl(element.FormControlName,new FormControl(e.data[0][element.FormControlName], [Validators.required,Validators.pattern(element.FormPattern)]));
         
              }
               } else {
              this.ExamAggForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
          }else{
            this.ExamAggForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        });
       this.mapdataaa(ress.data);
      });
 }
 
loadsettingspage() {
  let payload = {};
  payload['FormPage'] = 'AggregateExam';
  this.umsService.getStdSetting(payload).subscribe((res) => {
    
    res.data.forEach((element) => {
      if (element.FormVisible) {
        if (element.FormRequired) {
          if(element.FormPattern==''){
            
            this.ExamAggForm.addControl(element.FormControlName,new FormControl('', Validators.required));
          }
          else{
            this.ExamAggForm.addControl(element.FormControlName,new FormControl('', [Validators.required,Validators.pattern(element.FormPattern)]));
          }
        } else {
          this.ExamAggForm.addControl(element.FormControlName, new FormControl(''));
        }
      }
    });

   this.mapdataaa(res.data);
  });
}
mapdataaa(e){
  this.ExamAFormArray = e.reduce(function (r, a) {
    r[a.FormControlName] = r[a.FormControlName] || [];
    r[a.FormControlName].push(a);
    return r;
  }, Object.create(null));
}
 
}
